import React, { Component } from "react";  
import Swal from "sweetalert2";  
  

 function SweetAlertSuccess(props) {  
    Swal.fire({  
      title: 'Boa...',  
      type: 'success',  
      icon: 'success',  
       text: props.texto,  
    });    
}; 

function SweetAlertSuccessTopEnd(props) {  
 
    Swal.fire({  
      position: 'top-end',  
      icon: 'success',  
      title: props.texto,  
      showConfirmButton: false,  
      timer: 1500  
    });  
  };


function SweetAlertError(props){
    Swal.fire({  
        title: 'Ops...',  
        type: 'error',  
        icon: 'error',  
         text: props.texto,  
      });  
 
   };

function SweetAlertWarning(props) {  
    Swal.fire({  
      title: 'Atenção!',  
      type: 'warning',  
      icon: 'warning',  
       text: props.texto,  
    });    
}; 

function SweetAlertConfirm(props) { 
         Swal.fire({  
              title: 'Confrma?',  
              text: props.texto,  
              icon: 'question', 
              showCancelButton: true,  
              confirmButtonColor: '#3085d6',  
              cancelButtonColor: '#d33',  
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não'

         });  
} 

 export { SweetAlertSuccess, SweetAlertSuccessTopEnd, SweetAlertError, SweetAlertWarning, SweetAlertConfirm};


// export default class Sweetalertdemo extends Component {  
  
//   constructor() {  
//     super();  
//     this.HandleClick = this.HandleClick.bind(this);  
//   }  
  
//   HandleClick() {  
//     Swal.fire({  
//       title: 'Success',  
//       type: 'success',  
//       icon: 'success',  
//        text: 'Your work has been saved.',  
//     });  
//   }  
//   HandleClick1() {  
//     Swal.fire({  
//       title: 'Are you sure?',  
//       text: 'User will have Admin Privileges',  
//       icon: 'warning',  
//       showCancelButton: true,  
//       confirmButtonColor: '#3085d6',  
//       cancelButtonColor: '#d33',  
//       confirmButtonText: 'Yes!'  
//     });  
//   }  
//   HandleClick12() {  
//     Swal.fire({  
//       icon: 'error',  
//       title: 'Oops...',  
//       text: 'Something went wrong!',  
//       footer: '<a href>Why do I have this issue?</a>'  
//     });  
//   }  
//   HandleClicktop() {  
//     Swal.fire({  
//       position: 'top-end',  
//       icon: 'success',  
//       title: 'Your work has been saved',  
//       showConfirmButton: false,  
//       timer: 1500  
//     });  
//   }  
//   HandleClickAutoclose() {  
//     let timerInterval  
//     Swal.fire({  
//       title: 'Auto close alert!',  
//       html: 'I will close in <b></b> milliseconds.',  
//       timer: 1000,  
//       timerProgressBar: true,  
//       onBeforeOpen: () => {  
//         Swal.showLoading()  
//         timerInterval = setInterval(() => {  
//           const content = Swal.getContent()  
//           if (content) {  
//             const b = content.querySelector('b')  
//             if (b) {  
//               b.textContent = Swal.getTimerLeft()  
//             }  
//           }  
//         }, 100)  
//       },  
//       onClose: () => {  
//         clearInterval(timerInterval)  
//       }  
//     }).then((result) => {  
//       if (result.dismiss === Swal.DismissReason.timer) {  
//         console.log('I was closed by the timer')  
//       }  
//     })  
//   }  
  
  
//   render() {  
//     return (  
//       <div>  
//         <div class="row" className="hdr">  
//           <div class="col-sm-12 btn btn-info">  
//             SweetAlert2 In React  
  
//                          </div>  
//         </div>  
//         <div style={{ "paddingTop": "10px" }}>  
//           <button class="btn btn-info btn" onClick={this.HandleClick}>Success</button>  
//           <button class="btn btn-success btn" onClick={this.HandleClick1}>Confirm</button>  
//           <button class="btn btn-primary btn" onClick={this.HandleClick12}>Confirm Box</button>  
//           <button class="btn btn-primary btn" onClick={this.HandleClicktop}>Top Side</button>  
//           <button class="btn btn-primary btn" onClick={this.HandleClickAutoclose}>Auto Close</button>  
  
//         </div>  
//       </div>  
//     );  
//   }  
// }

// export default SwalSuccess;
